import { Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Restaurant, MenuBook, CalendarMonth } from '@mui/icons-material';
import ChoiceCard from '../components/ChoiceCard/ChoiceCard';

const Home = () => {
  const navigate = useNavigate();

  return (
    <Stack spacing={3} sx={{ maxWidth: 500, mx: 'auto', mt: 2 }}>
      <ChoiceCard
        icon={<Restaurant />}
        title="Potřebuješ poradit co uvařit?"
        variant="large"
        onClick={() => navigate('/cooking-guidance')}
      />
      <ChoiceCard
        icon={<MenuBook />}
        title="Spravuj svou sbírku receptů"
        variant="large"
        onClick={() => navigate('/recipe-management')}
      />
      <ChoiceCard
        icon={<CalendarMonth />}
        title="Naplánuj si jídla na příští dny"
        variant="large"
        onClick={() => navigate('/meal-plans')}
      />
    </Stack>
  );
};

export default Home;
